<div class="d-flex flex-column justify-content-between vh-100 login-wrapper">
  <app-navbar></app-navbar>
  <main class="login-page d-flex flex-fill align-items-center">
    <section class="banner-area w-100 h-100 p-0">
      <div class="car-background w-100 h-100">
        <div class="container h-100">
          <div class="row align-items-center h-100">
            <div class="col-md-5">
              <h1 class="fw-bold mb-4">
                Log In To <span>Your</span>, Dashboard <span>Account</span>
              </h1>
              <p class="mb-5">Welcome back! Please enter your details.</p>
              <div class="d-flex flex-wrap align-items-center">
                <div class="clients">
                  <h3 class="fw-bold">80+</h3>
                  <h4 class="m-0">Clients</h4>
                </div>
                <div class="end-users">
                  <h3 class="fw-bold">100,000</h3>
                  <h4 class="m-0">End users</h4>
                </div>
                <div class="countries">
                  <h3 class="fw-bold">40+</h3>
                  <h4 class="m-0">Countries</h4>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card shadow element-radius border-0 p-5">
                <div class="card-body">
                  <form #authFormDirective [formGroup]="auth" (submit)="login()">
                    <div class="form-group mb-3">
                      <label for="exampleInputEmail1" class="mb-2 fw-bold">Email</label>
                      <input
                        type="email"
                        name="email"
                        formControlName="email"
                        placeholder="{{ 'login.username' | translate }}"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        autoautocomplete="off"
                        [class.is-invalid]="formData.email.invalid && this.submitted"
                      />
                      <div class="form-errors" *ngIf="formData.email.invalid && this.submitted">
                        <p class="form-errors__error" *ngIf="formData.email.errors.required">
                          Email is reqired.
                        </p>
                        <p
                          class="form-errors__error"
                          *ngIf="!formData.email.errors.required && formData.email.errors"
                        >
                          Invalid email format
                        </p>
                      </div>
                      <!-- <small id="emailHelp" class="form-text text-muted"
                        >We'll never share your email with anyone else.</small
                      > -->
                    </div>
                    <div class="form-group mb-3">
                      <label for="exampleInputPassword1" class="mb-2 fw-bold">Password</label>
                      <input
                        type="password"
                        class="form-control"
                        name="password"
                        formControlName="password"
                        placeholder="{{ 'login.password' | translate }}"
                        id="exampleInputPassword1"
                        [class.is-invalid]="formData.password.invalid && this.submitted"
                      />
                      <div class="form-errors" *ngIf="formData.password.invalid && this.submitted">
                        <p class="form-errors__error" *ngIf="formData.password.errors.required">
                          Password is reqired.
                        </p>
                        <p
                          class="form-errors__error"
                          *ngIf="!formData.password.errors.required && formData.password.errors"
                        >
                          Password must be atleast 8 characters.
                        </p>
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="custom-control custom-switch m-0">
                            <input
                              type="radio"
                              name="lang"
                              formControlName="lang"
                              value="en"
                              class="custom-control-input"
                              id="eng"
                              (change)="setLocale('en')"
                            />
                            <label
                              class="custom-control-label"
                              for="eng"
                              [class.disabled]="auth.get('lang')?.value === 'ar'"
                            >
                              In English
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="custom-control custom-switch m-0">
                            <input
                              type="radio"
                              name="lang"
                              formControlName="lang"
                              value="ar"
                              class="custom-control-input"
                              id="ar"
                              (change)="setLocale('ar')"
                            />
                            <label
                              class="custom-control-label"
                              for="ar"
                              [class.disabled]="auth.get('lang')?.value === 'en'"
                            >
                              {{ 'login.arabic' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div
                      class="form-group form-check mb-3 d-flex justify-content-between align-items-center"
                    >
                      <div class="checkbox-area">
                        <input type="checkbox" class="form-check-input" id="exampleCheck1" />
                        <label class="form-check-label" for="exampleCheck1">{{
                          'login.remember_me' | translate
                        }}</label>
                      </div>
                      <div class="forgot-password-link">
                        <a routerLink="/forgot-password" class="text-decoration-none text-muted">{{
                          'login.forgot_password' | translate
                        }}</a>
                      </div>
                    </div> -->
                    <button
                      type="submit"
                      class="btn btn-primary px-4 py-2 w-100 mb-3"
                      [disabled]="loaded"
                    >
                      {{ 'login.login' | translate }}
                      <span class="spinner-grow spinner-grow-sm text-light ml-2" [hidden]="!loaded">
                      </span>
                    </button>
                    <!-- <div class="form-group my-3">
                      <small id="emailHelp" class="form-text text-muted"
                        >Don’t have an account?</small
                      >
                      <a href="#" class="text-decoration-none text-muted fw-bold">Sign Up</a>
                    </div> -->

                    <a
                      href="{{ dmsURL }}"
                      target="_blank"
                      class="btn btn__secondary px-4 py-2 w-100"
                    >
                      <!-- <span class="icon icon-lg w-100">
                        <img src="/assets/images/siarty_logo.svg" alt="" />
                      </span> -->
                      CEN
                    </a>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer></app-footer>
</div>
